import sanitize from 'sanitize-html';
import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {palette} from '@/styles';
import Img from './empty.svg';

export const NoData = ({text}: {text: string}) => {
  return (
    <Root>
      {!!text?.length && (
        <Typography
          variant="medium14"
          lineHeight="normal"
          color={palette.gray600}
          align="center"
          dangerouslySetInnerHTML={{
            __html: sanitize(text),
          }}
        />
      )}
      <img src={Img} alt={text} />
    </Root>
  );
};

const Root = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
